import { InputNumber } from "antd";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";

interface AmountInputProps {
  amount: number;
  max: number;
  onChange: any;
}

export const AmountInput = ({ amount, max, onChange }: AmountInputProps) => {
  const [v, setV] = useState(Number.isFinite(amount) ? amount : 0);

  useEffect(() => {
    onChange(v);
  }, [v]);

  useEffect(() => {
    setV(Number.isFinite(amount) ? amount : 0);
  }, [amount]);

  const changeHandler = (value: string | null) => {
    if (!value) {
      setV(0);
      return;
    }
    if (!Number.isFinite(max)) {
      setV(0);
      return;
    }
    if (max >= +value) {
      setV(+value);
      return;
    }
    if (max < +value) {
      setV(max);
      return;
    }
  };

  const debouncedChangeHandler = useCallback(debounce(changeHandler, 300), [
    max,
  ]);

  return (
    <InputNumber
      className="custom-number-input"
      value={`${v}`}
      formatter={(value?: string) =>
        `${value ?? 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
      parser={(value?: string) => value!.replace(/(,*)/g, "")}
      onChange={debouncedChangeHandler}
    />
  );
};
